import SurveyFinish from 'components/pages/SurveyFinish/SurveyFinish';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('surveys');
export default buildPage(SurveyFinish, {
  skipSSR: true,
  requiresAuthentication: false,
  metaData: {
    title: 'Survey Finish',
    description: 'Survey Finish',
  },
});
